import React, { useState, useEffect } from 'react';
import '../../css/StreamSelector.css'; // Import the CSS file
import { useRobotDetails } from '../../utilities/RobotDetailsContext';
import { CameraStreams } from '../../components/Pages/HomePage';
import { useOperator } from '../../utilities/http/routing/OperatorContext';

interface StreamSelectorProps {
  updateStream: (stream: CameraStreams) => void;
}

const streamLabels: Record<string, string> = {
  front: "Front Camera",
  rear: "Rear Camera",
  ptz: "PTZ Camera",
  thermal: "Thermal Camera",
  gas: "Gas Camera",
  none: "None",
};

export const StreamSelector: React.FC<StreamSelectorProps> = ({ updateStream }) => {
  const [selectedStream, setSelectedStream] = useState<CameraStreams>('ptz');
   const { isOperator } = useOperator();
  const {robotDetails} = useRobotDetails();
  useEffect(() => {
    // Call updateStream with the default stream on component mount
    updateStream(selectedStream);
  }, [selectedStream, updateStream]);

  const handleButtonClick = (stream: CameraStreams) => {
    setSelectedStream(stream);
    updateStream(stream);
  };
  const availableStreams = [
  'ptz',
  ...(robotDetails.hasThermal ? ['thermal'] : []),
  ...(robotDetails.hasGas ? ['gas'] : []),
  ];

  const handleCameraCycle = () => {
    const currentIndex = availableStreams.indexOf(selectedStream);
    const nextIndex = (currentIndex + 1) % availableStreams.length;

    handleButtonClick(availableStreams[nextIndex] as CameraStreams);
  };

  const getNextStreamLabel = () => {
    const currentIndex = availableStreams.indexOf(selectedStream);
    const nextIndex = (currentIndex + 1) % availableStreams.length;

    return availableStreams[nextIndex] === 'ptz'
      ? 'PTZ'
      : availableStreams[nextIndex] === 'thermal'
        ? 'Thermal'
        : 'Gas';
  };

  return (
    <div>
      <div className="active-cam-box">
        <span>Active Cam</span>
        <span>{streamLabels[selectedStream] ?? selectedStream}</span>
        
      </div>
      {(isOperator && selectedStream !== 'none') &&
        <button
          onClick={() => handleButtonClick('none')}
        >
          x
        </button>}
      <div>
        <button
          className={selectedStream === 'front' ? 'selected' : ''}
          onClick={() => handleButtonClick('front')}
        >
          Front
        </button>
        <button
          className={selectedStream === 'rear' ? 'selected' : ''}
          onClick={() => handleButtonClick('rear')}
        >
          Rear
        </button>
        <button
          className={selectedStream === 'ptz' ? 'selected' : ''}
          onClick={handleCameraCycle}
        >
          {getNextStreamLabel()}
        </button>
        
      </div>
    </div>
    
  );
};

export default StreamSelector;
